module.exports = __webpack_public_path__ + "img/play.68cfc6ef.svg";